import { Dialog, DialogTitle, IconButton, type DialogProps } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useCallback, type PropsWithChildren, type ReactNode } from "react";

export type Props = PropsWithChildren<
  {
    title: ReactNode;
    onClose: () => void;
  } & Omit<DialogProps, "onClose" | "maxWidth" | "fullWidth" | "title">
>;

export function ModalDialog({
  title,
  children,
  onClose,
  scroll = "paper",
  ...props
}: Props) {
  const handleClose = useCallback(
    (_: unknown, reason: "backdropClick" | "escapeKeyDown") => {
      // ignore click-away events
      if (reason === "backdropClick") return;
      onClose();
    },
    [onClose]
  );

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      scroll={scroll}
      onClose={handleClose}
      {...props}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {children}
    </Dialog>
  );
}
